module.exports = __webpack_public_path__ + "static/media/wind.e817e14f.ogg";